import { Button } from '@mui/material'
import { useState } from 'react'

import { ProfitDialog } from './ProfitDialog'

export const ProfitSummaryButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)} sx={{ mb: 2 }}>
        Profit Summary
      </Button>
      {open && <ProfitDialog setOpen={setOpen} />}
    </>
  )
}
